/* Al Hayat v2: slideshow, carousels, shop the room, reviews, steps, delivery meter + ETA,
   collection filters / load more / quick view. Vanilla, no dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const small = matchMedia('(max-width: 860px)');
  const aed = (c) => 'AED ' + Math.round(c / 100).toLocaleString('en-US');
  const esc = (t) => String(t).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));

  /* ---------- Lazy ambient videos (story, tiles, collection film) ---------- */
  function wireVideo(v) {
    if (reduce || !v || v.dataset.wired) return;
    v.dataset.wired = '1';
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        if (!v.src && v.dataset.src) v.src = v.dataset.src;
        v.play().then(() => v.classList.add('is-playing')).catch(() => {});
      } else v.pause();
    }, { rootMargin: '200px' }).observe(v);
  }
  $$('video[data-src]').forEach(wireVideo);

  /* ---------- Hero slideshow with living photos ---------- */
  // Size the hero to the space under the sticky header so the buttons are never below the fold.
  const setTop = () => { const hero = $('.ah-slides'); if (!hero) return; const top = hero.getBoundingClientRect().top + scrollY; document.documentElement.style.setProperty('--ah-top', Math.max(56, Math.round(top)) + 'px'); };
  setTop(); addEventListener('resize', setTop, { passive: true });
  $$('.ah-slides').forEach((root) => {
    const slides = $$('.ah-slide', root), bars = $$('.ah-slides__prog b', root), num = $('[data-slide-n]', root);
    if (!slides.length) return;
    const DUR = +root.dataset.interval || 7000;
    let i = 0, t0 = performance.now(), paused = reduce, hover = false, held = 0;
    const srcFor = (s) => (small.matches ? s.dataset.videoMobile || s.dataset.video : s.dataset.video);
    // Living photo: plays once from the frame the still shows, then holds its last frame.
    const play = (s) => {
      const v = $('video', s), src = srcFor(s); if (!v || reduce || !src) return;
      if (!v.src) { v.src = src; v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true }); }
      try { v.currentTime = 0; } catch (_) {}
      v.play().catch(() => {});
    };
    const go = (n) => {
      const prev = slides[i]; i = (n + slides.length) % slides.length; const cur = slides[i];
      if (prev !== cur) { prev.classList.remove('is-on'); setTimeout(() => { const pv = $('video', prev); if (pv) { pv.pause(); pv.classList.remove('is-playing'); } }, 1100); }
      cur.classList.add('is-on'); play(cur);
      if (num) num.textContent = String(i + 1).padStart(2, '0');
      const nx = slides[(i + 1) % slides.length], nv = $('video', nx);
      if (nv && !nv.src && !reduce && srcFor(nx)) { nv.preload = 'auto'; nv.src = srcFor(nx); nv.addEventListener('playing', () => nv.classList.add('is-playing'), { once: true }); }
      t0 = performance.now(); held = 0;
    };
    play(slides[0]);
    const tick = (t) => {
      const stop = paused || hover;
      if (stop) t0 = t - held; else held = t - t0;
      bars.forEach((b, j) => (b.style.width = j < i ? '100%' : j === i ? Math.min(1, held / DUR) * 100 + '%' : '0%'));
      if (!stop && held >= DUR) go(i + 1);
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    $$('[data-dir]', root).forEach((b) => b.addEventListener('click', () => go(i + +b.dataset.dir)));
    const pb = $('[data-pause]', root);
    pb?.addEventListener('click', () => { paused = !paused; pb.setAttribute('aria-pressed', paused); pb.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); const v = $('video', slides[i]); if (v && v.src) paused ? v.pause() : v.play().catch(() => {}); });
    const media = $$('.ah-slide__media', root);
    media.forEach((m) => { m.addEventListener('mouseenter', () => (hover = true)); m.addEventListener('mouseleave', () => (hover = false)); });
    root.addEventListener('focusin', () => (hover = true));
    root.addEventListener('focusout', () => (hover = false));
    let sx = null;
    root.addEventListener('pointerdown', (e) => { if (!e.target.closest('a,button')) sx = e.clientX; });
    root.addEventListener('pointerup', (e) => { if (sx != null && Math.abs(e.clientX - sx) > 50) go(i + (e.clientX < sx ? 1 : -1)); sx = null; });
    document.addEventListener('visibilitychange', () => { const v = $('video', slides[i]); if (!v) return; if (document.hidden) v.pause(); else if (!paused && v.src && !v.ended) v.play().catch(() => {}); });
  });

  /* ---------- Mega menu: the photo follows the link under the pointer ---------- */
  $$('[data-ah-mega]').forEach((mega) => {
    const fig = $('.ah-mega__pic', mega), cap = $('figcaption', fig); if (!fig) return;
    let img = $('img', fig), cur = img ? img.currentSrc || img.src : '';
    $$('.ah-mega__links a', mega).forEach((a) => {
      if (a.dataset.img) { const pre = new Image(); pre.src = a.dataset.img; }
      a.addEventListener('pointerenter', () => {
        $$('.ah-mega__links a', mega).forEach((x) => x.classList.toggle('is-on', x === a));
        if (cap) cap.textContent = a.dataset.cap;
        if (!a.dataset.img || a.dataset.img === cur) return;
        cur = a.dataset.img;
        // Crossfade: every other photo fades out while the new one fades in, so they never double-expose.
        const next = document.createElement('img'); next.src = cur; next.alt = ''; next.className = 'is-in';
        fig.insertBefore(next, cap); img = next; classify(next);
        const settle = () => {
          if (img !== next) return next.remove();
          next.classList.remove('is-in');
          $$('img', fig).forEach((o) => { if (o !== next) { o.classList.add('is-out'); setTimeout(() => o.remove(), 520); } });
        };
        let done = false; const go = () => { if (!done) { done = true; settle(); } };
        if (next.complete && next.naturalWidth) setTimeout(go, 16); else { next.addEventListener('load', go, { once: true }); next.addEventListener('error', go, { once: true }); }
        setTimeout(go, 1200);
      });
    });
  });

  /* ---------- Category index: the stage photo follows the row under the pointer ---------- */
  $$('[data-ah-index]').forEach((list) => {
    const sec = list.closest('.ah-index'), rows = $$('.ah-irow', list), pics = $$('.ah-index__pic', sec);
    let cur = '0', tm;
    const show = (i) => {
      if (i === cur) return;
      rows.forEach((r) => r.classList.toggle('is-on', r.dataset.i === i));
      pics.forEach((p) => { p.classList.remove('was-on'); if (p.dataset.i === cur) p.classList.add('was-on'); p.classList.toggle('is-on', p.dataset.i === i); });
      cur = i; clearTimeout(tm); tm = setTimeout(() => pics.forEach((p) => p.classList.remove('was-on')), 850);
    };
    rows.forEach((r) => { r.addEventListener('pointerenter', () => show(r.dataset.i)); r.addEventListener('focus', () => show(r.dataset.i)); });
  });

  /* ---------- Carousels: drag, arrows, keys ---------- */
  $$('[data-ah-carousel]').forEach((track) => {
    const sec = track.closest('section');
    const step = () => (track.firstElementChild?.getBoundingClientRect().width || 300) + 22;
    $$('[data-car]', sec).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: step() * +b.dataset.car * 2, behavior: 'smooth' })));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: step() * (e.key === 'ArrowRight' ? 1 : -1), behavior: 'smooth' }); } });
    let down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); } track.scrollLeft = sl - dx; });
    addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => track.classList.remove('is-drag'), 0); });
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  /* ---------- Shop the room: a dot opens its piece's card ---------- */
  $$('[data-ah-sr2]').forEach((fig) => {
    const spots = $$('.ah-spot', fig), pops = $$('.ah-sr2__pop', fig);
    const set = (n) => {
      spots.forEach((s) => s.setAttribute('aria-expanded', String(s.dataset.spot === String(n))));
      pops.forEach((p) => { p.hidden = p.dataset.pop !== String(n); });
    };
    spots.forEach((s) => s.addEventListener('click', () => {
      const on = s.getAttribute('aria-expanded') === 'true'; set(on ? -1 : s.dataset.spot);
      if (!on && small.matches) pops.find((p) => p.dataset.pop === s.dataset.spot)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }));
    $$('[data-close]', fig).forEach((b) => b.addEventListener('click', () => set(-1)));
    // A click anywhere outside the dots and cards closes the open card (the cards' own buttons still reach ah.js).
    document.addEventListener('click', (e) => { if (!e.target.closest('.ah-spot, .ah-sr2__pop')) set(-1); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(-1); });
  });

  /* ---------- Reviews marquee ---------- */
  $$('[data-ah-marquee]').forEach((vp) => {
    const tr = $('.ah-rev-track', vp); if (!tr || reduce) return;
    Array.from(tr.children).forEach((li) => { const c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); tr.append(c); });
    tr.style.setProperty('--ah-marquee', Math.max(30, tr.children.length * 5) + 's');
  });

  /* ---------- How ordering works: light the steps in order ---------- */
  $$('[data-ah-steps]').forEach((row) => {
    const steps = $$('.ah-step', row);
    new IntersectionObserver(([e], o) => {
      if (!e.isIntersecting) return; o.disconnect();
      row.style.setProperty('--ah-steps-p', 1);
      steps.forEach((s, k) => setTimeout(() => s.classList.add('is-lit'), reduce ? 0 : 250 + k * 380));
    }, { threshold: 0.4 }).observe(row);
  });

  /* ---------- Free-delivery meter ---------- */
  const meters = $$('[data-ah-meter]');
  function paintMeter(m, cartTotal, add) {
    const free = +m.dataset.free, fee = +m.dataset.fee, total = cartTotal + add, left = free - total;
    m.style.setProperty('--pct', Math.min(100, (total / free) * 100) + '%');
    m.classList.toggle('is-free', left <= 0);
    const msg = $('.ah-meter__msg', m);
    if (left <= 0) msg.innerHTML = `<b>${m.dataset.context === 'product' && cartTotal === 0 ? 'Free delivery on this piece' : 'Free delivery unlocked'}</b><span>Anywhere in the UAE. You save AED ${fee}.</span>`;
    else msg.innerHTML = `<b>${aed(left)} away from free delivery</b><span>Delivery is AED ${fee} on orders below ${aed(free)}.</span>`;
  }
  document.addEventListener('ah:variant', (e) => meters.forEach((m) => { if (m.dataset.context === 'product') { m.dataset.add = e.detail.price; paintMeter(m, +m.dataset.cart, +m.dataset.add); } }));
  document.addEventListener('ah:cart', async () => {
    try {
      const c = await (await fetch('/cart.js')).json();
      meters.forEach((m) => { m.dataset.cart = c.total_price; if (m.dataset.context === 'product') m.dataset.add = 0; paintMeter(m, c.total_price, +m.dataset.add); });
    } catch (_) {}
  });

  /* ---------- Delivery estimate: cut-off + business days, Gulf time ---------- */
  const paintEta = (el) => {
    if (el.dataset.painted) return; el.dataset.painted = '1';
    const days = el.dataset.days.split(',').map(Number), [ch, cm] = el.dataset.cutoff.split(':').map(Number);
    const min = +el.dataset.min, max = +el.dataset.max;
    const now = new Date(Date.now() + (4 * 60 + new Date().getTimezoneOffset()) * 60000); // wall clock in GMT+4
    const isBiz = (d) => days.includes(d.getDay());
    let start = new Date(now); const before = now.getHours() * 60 + now.getMinutes() < ch * 60 + cm;
    if (!isBiz(start) || !before) { do { start.setDate(start.getDate() + 1); } while (!isBiz(start)); }
    const addBiz = (d, n) => { const x = new Date(d); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (isBiz(x)) k++; } return x; };
    const f = (d) => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    // One window from order to door, making time included: customers read a bare "delivered in 6 to 10 days" as the drive alone.
    $('[data-ah-eta-range]', el).textContent = `Made to order, at your door ${f(addBiz(start, min - 1))} to ${f(addBiz(start, max - 1))}`;
    const note = $('[data-ah-eta-note]', el);
    if (isBiz(now) && before) {
      const mins = ch * 60 + cm - (now.getHours() * 60 + now.getMinutes());
      note.textContent = `Making time included. Order in the next ${Math.floor(mins / 60)}h ${mins % 60}m and we start today.`;
    } else note.textContent = `Making time included. Orders placed now start on ${f(start)}.`;
  };
  const etaAll = (root = document) => $$('[data-ah-eta]:not([data-painted])', root).forEach(paintEta);
  etaAll();

  /* ---------- Cart drawer: complete the room ----------
     Two related pieces for the first item in the cart (Shopify recommendations), skipping anything
     already in the cart and preferring a different kind of piece. Refilled after every drawer render. */
  const recsCache = new Map();
  const plusSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  async function fillRecs(box) {
    if (box.dataset.done) return; box.dataset.done = '1';
    const pid = box.dataset.pid, have = new Set((box.dataset.have || '').split(',').map(Number)), type = box.dataset.type;
    if (!pid) return;
    let list = recsCache.get(pid);
    if (!list) {
      // Rendered through the ah-recs section so each piece can use its studio picture.
      try {
        const r = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}recommendations/products?product_id=${pid}&limit=10&intent=related&section_id=ah-recs`);
        const m = (await r.text()).match(/<script type="application\/json" data-ah-recs-json>([\s\S]*?)<\/script>/);
        list = m ? JSON.parse(m[1]) : [];
      } catch (_) { list = []; }
      recsCache.set(pid, list);
    }
    const pick = list.filter((p) => !have.has(p.id) && p.available).sort((a, b) => (a.type === type) - (b.type === type)).slice(0, 2);
    if (!pick.length) return;
    $('[data-recs-list]', box).innerHTML = pick.map((p) => {
      const img = p.img || '';
      return `<li class="ah-cd-rec"><a class="ah-cd-rec__img" href="${p.url}" tabindex="-1" aria-hidden="true">${img ? `<img src="${img}" alt="" loading="lazy" width="64" height="64">` : ''}</a><div class="ah-cd-rec__txt"><a class="ah-cd-rec__t" href="${p.url}">${esc(p.title)}</a><span class="ah-cd-rec__p">${p.price_varies ? 'From ' : ''}${aed(p.price)}</span></div>${p.variants > 1 ? `<a class="ah-cd-rec__add" href="${p.url}" aria-label="Choose options for ${esc(p.title)}">${plusSvg}<span>Options</span></a>` : `<button type="button" class="ah-cd-rec__add" data-ah-add="${p.variant_id}" aria-label="Add ${esc(p.title)} to cart">${plusSvg}<span>Add</span></button>`}</li>`;
    }).join('');
    box.hidden = false;
  }
  const recsAll = (root = document) => $$('[data-ah-recs]:not([data-done])', root).forEach(fillRecs);
  recsAll();

  /* ---------- Card photos: packshot or lifestyle? ----------
     A plain-background packshot is shown whole and blended into the card; a lifestyle photo fills
     the frame. Decided per photo from its border pixels (same-origin CDN, so the canvas can read it). */
  const probe = document.createElement('canvas');
  const pctx = probe.getContext('2d', { willReadFrequently: true });
  // Auto-frame a packshot: find the furniture's box inside the plain background, then scale and
  // centre that box in the frame with an even margin, so every piece reads at the same size.
  const frame = (img, box) => {
    const host = img.closest('.ah-card__media, .ah-mega__pic'); if (!host) return;
    const F = host.clientWidth / Math.max(1, host.clientHeight) || 1.5, r = img.naturalWidth / img.naturalHeight;
    const m = host.matches('.ah-mega__pic') ? 0.12 : F > 1.2 ? 0.1 : 0.09;
    const bw = Math.max(0.05, box[2] - box[0]), bh = Math.max(0.05, box[3] - box[1]);
    const sc = Math.min((1 - 2 * m) / bw, ((1 - 2 * m) * r) / (F * bh));
    const cx = (box[0] + box[2]) / 2, cy = (box[1] + box[3]) / 2, hPct = (sc * F) / r;
    Object.assign(img.style, { inset: 'auto', left: (0.5 - sc * cx) * 100 + '%', top: (0.5 - hPct * cy) * 100 + '%', width: sc * 100 + '%', height: hPct * 100 + '%', maxWidth: 'none', padding: '0', objectFit: 'fill' });
  };
  // A studio picture is square, with the piece standing on a floor line at 86 % of its height. In the wide menu
  // frame, scale it so the piece fills the frame (as large as fits in 80 % of the width and 66 % of the height,
  // never smaller than the frame's height) standing on a floor line at 80 %, which leaves the caption on the floor
  // in front of it. Sizes are in percent of the frame, so it holds at any width; the frame shares the pictures'
  // gradient and the picture's edges fade, so no seam shows.
  const studioFrame = (img) => {
    const fig = img.closest('.ah-mega__pic'); if (!fig) return;
    try {
      const N = 96; probe.width = N; probe.height = N; pctx.clearRect(0, 0, N, N); pctx.drawImage(img, 0, 0, N, N);
      const d = pctx.getImageData(0, 0, N, N).data, floor = Math.round(0.86 * N);
      let top = floor, x0 = N, x1 = -1;
      for (let y = 0; y < floor; y++) {
        const b = y * N * 4; let hits = 0;
        for (let x = 0; x < N; x++) {
          const i = b + x * 4;
          // Off the background when it differs from the row's left edge, which is always plain background.
          if (Math.abs(d[i] - d[b]) + Math.abs(d[i + 1] - d[b + 1]) + Math.abs(d[i + 2] - d[b + 2]) > 36) {
            hits++; if (y < 0.82 * N) { x0 = Math.min(x0, x); x1 = Math.max(x1, x); }
          }
        }
        if (hits >= 2 && y < top) top = y;
      }
      if (x1 <= x0 || top >= floor) return;
      const ar = (getComputedStyle(fig).aspectRatio || '').split('/').map(Number);
      const F = fig.clientHeight ? fig.clientWidth / fig.clientHeight : ar[1] ? ar[0] / ar[1] : 16 / 9;
      const bh = (floor - top) / N, bw = (x1 - x0 + 1) / N;
      const s = Math.min(2.6, Math.max(1.03, Math.min(0.66 / bh, (0.8 * F) / bw)));
      const w = (s / F) * 100;
      Object.assign(img.style, { inset: 'auto', left: (100 - w) / 2 + '%', top: (0.8 - 0.86 * s) * 100 + '%', width: w + '%', height: s * 100 + '%', maxWidth: 'none', objectFit: 'fill' });
      img.classList.add('is-framed');
    } catch (_) {}
  };
  const classify = (img) => {
    const run = () => {
      // Studio pictures (files named ah-studio-*) already sit on the shared background: show them as they are.
      if ((img.currentSrc || img.src).includes('/ah-studio-')) {
        img.removeAttribute('style'); img.classList.remove('is-pack'); img.classList.add('is-read', 'is-studio');
        studioFrame(img);
        return;
      }
      try {
        const r = img.naturalWidth / img.naturalHeight || 1, W = 64, H = Math.max(8, Math.round(64 / r));
        probe.width = W; probe.height = H; pctx.clearRect(0, 0, W, H); pctx.drawImage(img, 0, 0, W, H);
        const d = pctx.getImageData(0, 0, W, H).data, isBg = (i) => { const mn = Math.min(d[i], d[i + 1], d[i + 2]); return mn >= 226 && Math.max(d[i], d[i + 1], d[i + 2]) - mn <= 16; };
        let edge = 0, white = 0, x0 = W, y0 = H, x1 = -1, y1 = -1;
        const rows = new Array(H).fill(0), cols = new Array(W).fill(0);
        for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
          const bg = isBg((y * W + x) * 4);
          if (x < 2 || x > W - 3 || y < 2 || y > H - 3) { edge++; if (bg) white++; }
          if (!bg) { rows[y]++; cols[x]++; }
        }
        const pack = white / edge >= 0.85;
        img.classList.toggle('is-pack', pack);
        if (pack) {
          rows.forEach((n, y) => { if (n >= 2) { y0 = Math.min(y0, y); y1 = Math.max(y1, y); } });
          cols.forEach((n, x) => { if (n >= 2) { x0 = Math.min(x0, x); x1 = Math.max(x1, x); } });
          if (x1 > x0 && y1 > y0) frame(img, [x0 / W, y0 / H, (x1 + 1) / W, (y1 + 1) / H]);
        } else img.removeAttribute('style');
      } catch (_) {}
      img.classList.add('is-read');
    };
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
  };
  const classifyAll = (root = document) => $$('.ah-card__media .ah-ph img:not(.is-read), .ah-mega__pic img:not(.is-read)', root).forEach(classify);
  classifyAll();
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType !== 1) return; classifyAll(n); etaAll(n); recsAll(n); }))).observe(document.body, { childList: true, subtree: true });

  /* ---------- Card colour dots swap the photo ---------- */
  // Hovering a dot previews that colour; clicking keeps it (the card gets is-picked, which also stops the hover
  // photo covering it). Leaving the dots goes back to the kept colour. The new picture is loaded before it is shown.
  document.addEventListener('mouseover', (e) => swapDot(e.target.closest('.ah-dot')));
  document.addEventListener('click', (e) => { const d = e.target.closest('.ah-dot'); if (d) { e.preventDefault(); swapDot(d, true); } });
  document.addEventListener('mouseout', (e) => {
    const g = e.target.closest('.ah-dots'); if (!g || g.contains(e.relatedTarget)) return;
    const card = g.closest('.ah-card'), img = card && $('.ah-ph img', card); if (!img || !img.dataset.orig) return;
    showPic(card, img, $('.ah-dot.is-on', card)?.dataset.img || img.dataset.orig);
  });
  function showPic(card, img, src) {
    card.dataset.want = src;
    if (img.src === src) return;
    const pre = new Image(), go = () => { if (card.dataset.want !== src) return; img.removeAttribute('srcset'); img.classList.remove('is-read'); img.src = src; classify(img); };
    pre.src = src; if (pre.complete) go(); else pre.onload = go;
  }
  function swapDot(d, sticky) {
    if (!d || !d.dataset.img) return;
    const card = d.closest('.ah-card'), img = $('.ah-ph img', card); if (!img) return;
    img.dataset.orig ||= img.currentSrc || img.src;
    if (sticky) { card.classList.add('is-picked'); $$('.ah-dot', card).forEach((x) => x.classList.toggle('is-on', x === d)); }
    showPic(card, img, d.dataset.img);
  }

  /* ---------- Wishlist (this browser) ---------- */
  const WK = 'ah-wishlist';
  const getW = () => { try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (_) { return []; } };
  const setW = (a) => { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (_) {} };
  const paintW = () => { const w = getW(); $$('[data-ah-wish]').forEach((b) => b.setAttribute('aria-pressed', w.includes(b.dataset.ahWish))); };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ah-wish]'); if (!b) return; e.preventDefault();
    const w = getW(), h = b.dataset.ahWish, i = w.indexOf(h); i >= 0 ? w.splice(i, 1) : w.push(h); setW(w); paintW();
  });
  paintW();

  /* ---------- Quick view ---------- */
  let qv;
  function qvEl() {
    if (qv) return qv;
    qv = document.createElement('aside');
    qv.className = 'ah ah-qv'; qv.setAttribute('role', 'dialog'); qv.setAttribute('aria-modal', 'true'); qv.setAttribute('aria-label', 'Quick view'); qv.hidden = true;
    qv.innerHTML = '<div class="ah-qv__top"><span class="ah-k">Quick view</span><button type="button" class="ah-round ah-round--ink" data-qv-close aria-label="Close quick view"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div class="ah-qv__body"></div>';
    document.body.append(qv);
    qv.addEventListener('click', (e) => { if (e.target.closest('[data-qv-close]')) closeQv(); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && qv.classList.contains('is-open')) closeQv(); });
    return qv;
  }
  let lastFocus;
  function closeQv() { qv.classList.remove('is-open'); setTimeout(() => (qv.hidden = true), 420); lastFocus?.focus?.(); }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-ah-qv]'); if (!b) return; e.preventDefault();
    lastFocus = b; const el = qvEl(), body = $('.ah-qv__body', el);
    body.innerHTML = '<p class="ah-k">Loading…</p>'; el.hidden = false; requestAnimationFrame(() => el.classList.add('is-open'));
    try {
      const p = await (await fetch(`/products/${b.dataset.ahQv}.js`)).json();
      let v = p.variants.find((x) => x.available) || p.variants[0];
      const colourHex = (n) => (b.closest('.ah-card') ? $$('.ah-dot', b.closest('.ah-card')).find((d) => d.getAttribute('aria-label') === n)?.style.getPropertyValue('--c') : '') || '';
      const render = () => {
        body.innerHTML = `
          <div class="ah-qv__gal">${(v.featured_image ? [v.featured_image.src, ...p.images.filter((s) => s !== v.featured_image.src)] : p.images).slice(0, 6).map((s) => `<img src="${s}${s.includes('?') ? '&' : '?'}width=900" alt="" loading="lazy">`).join('')}</div>
          <h2 class="ah-display">${esc(p.title)}</h2>
          <span class="ah-price">${aed(v.price)}${v.compare_at_price > v.price ? `<s>${aed(v.compare_at_price)}</s>` : ''}</span>
          ${p.options.filter((o) => !(o.name === 'Title' && o.values[0] === 'Default Title')).map((o, oi) => `
            <div><span class="ah-k">${esc(o.name)}</span><div class="ah-qv__opts" data-oi="${oi}">${o.values.map((val) => { const hx = colourHex(val); return `<button type="button" data-val="${esc(val)}" aria-pressed="${v.options[oi] === val}">${hx ? `<i style="--c:${hx}"></i>` : ''}${esc(val)}</button>`; }).join('')}</div></div>`).join('')}
          <div class="ah-row" style="display:flex;gap:10px;flex-wrap:wrap"><button type="button" class="ah-btn" data-qv-add ${v.available ? '' : 'disabled'}>${v.available ? 'Add to cart' : 'Sold out'}</button><a class="ah-btn ah-btn--ghost" href="${p.url}?variant=${v.id}">Full details</a></div>`;
        $$('.ah-qv__opts button', body).forEach((ob) => ob.addEventListener('click', () => {
          const oi = +ob.parentElement.dataset.oi, sel = [...v.options]; sel[oi] = ob.dataset.val;
          v = p.variants.find((x) => x.options.every((o, k) => o === sel[k])) || v; render();
        }));
        $('[data-qv-add]', body)?.addEventListener('click', (ev) => window.ahAdd?.([{ id: v.id, quantity: 1 }], ev.currentTarget).then(closeQv).catch((err) => alert(err.message)));
      };
      render(); $('[data-qv-close]', el).focus();
    } catch (_) { body.innerHTML = '<p>Could not load this product. <a href="/products/' + esc(b.dataset.ahQv) + '">Open it</a>.</p>'; }
  });

  /* ---------- Collection: filter bar, filter panel, load more ---------- */
  const plp = $('.ah-plp2');
  if (plp) {
    const grid = $('#ah-pgrid', plp), sid = plp.dataset.section, base = plp.dataset.url;
    const pages = +plp.dataset.pages, total = +plp.dataset.total, perPage = $$('.ah-card', grid).length || 24;
    const st = { kinds: new Set(), wall: null, min: 0, max: null, colours: new Set(), sale: false, sort: 'feat' };
    const FAM = { Green: '#5F7356', Burgundy: '#7A2232', Blue: '#4C5F78', Black: '#2A2724', Grey: '#9A978F', White: '#EFEAE0', Brown: '#6B3F22', Ochre: '#C49A45', Beige: '#D9CBB2', Pink: '#D9A7A0' };
    const cards = () => $$('.ah-card', grid);
    const tiles = () => $$('[data-tile]', grid);
    let pool = [], fetching = null;

    // Later pages load quietly into a pool, so counts and filters cover the whole collection.
    const fetchNodes = async (n) => {
      const r = await fetch(`${base}?page=${n}&section_id=${sid}`);
      const g = new DOMParser().parseFromString(await r.text(), 'text/html').getElementById('ah-pgrid');
      return g ? Array.from(g.children) : [];
    };
    const fetchAll = () => fetching ||= (async () => { for (let n = +plp.dataset.page + 1; n <= pages; n++) pool.push(...(await fetchNodes(n))); refreshOptions(); paintMore(); })();
    const allCards = () => [...cards(), ...pool.filter((n) => n.matches('.ah-card'))];
    const reveal = (nodes) => { nodes.forEach((n) => { n.classList.add('is-new'); grid.append(n); }); $$('video[data-src]', grid).forEach(wireVideo); paintW(); };
    const revealAll = () => { reveal(pool); pool = []; };
    if (pages > 1) { if (window.requestIdleCallback) requestIdleCallback(() => fetchAll(), { timeout: 2500 }); else setTimeout(fetchAll, 1200); }

    // Options: counts, chips, colours
    function refreshOptions() {
      const all = allCards();
      let kindsWithItems = 0;
      $$('[data-count]', plp).forEach((el) => { const n = all.filter((c) => c.dataset.k === el.dataset.count).length; el.textContent = n; const host = el.closest('.ah-qchip, .ah-fchip'); if (host) host.hidden = !n; });
      $$('.ah-qchip[data-kindchip]:not([data-kindchip=""])', plp).forEach((c) => { if (!c.hidden) kindsWithItems++; });
      const q = $('.ah-qchips', plp); if (q) q.hidden = kindsWithItems < 2;
      const ft = $('[data-fsec="type"]', plp); if (ft) ft.hidden = kindsWithItems < 2;
      const fams = new Map(); all.forEach((c) => (c.dataset.colours || '').split(',').filter(Boolean).forEach((f) => fams.set(f, (fams.get(f) || 0) + 1)));
      const box = $('[data-colours]', plp);
      if (box) box.innerHTML = [...fams].sort((a, b) => b[1] - a[1]).map(([f, n]) => `<button type="button" class="ah-cswatch" data-colour="${f}" aria-pressed="${st.colours.has(f)}"><i style="--c:${FAM[f] || '#ccc'}"></i><span>${f}</span><em>${n}</em></button>`).join('') || '<p class="ah-fsec__note">No colour options in this collection.</p>';
    }

    // Load more
    const moreBox = $('[data-more]', plp), moreBtn = $('[data-more-btn]', plp);
    const paintMore = () => {
      if (!moreBox) return;
      const n = cards().length;
      $('[data-more-label]', moreBox).textContent = `Showing ${Math.min(n, total)} of ${total}`;
      $('.ah-more2__track b', moreBox).style.width = Math.min(100, (n / total) * 100) + '%';
      if (moreBtn) moreBtn.hidden = n >= total;
    };
    moreBtn?.addEventListener('click', async (e) => {
      e.preventDefault(); moreBtn.classList.add('is-loading');
      await fetchAll(); moreBtn.classList.remove('is-loading');
      let k = 0; const take = []; while (pool.length && k < perPage) { const n = pool.shift(); take.push(n); if (n.matches('.ah-card')) k++; }
      reveal(take); apply(false); paintMore();
    });

    // Filtering with FLIP
    const active = () => st.kinds.size || st.wall || st.min || st.max || st.colours.size || st.sale;
    const nActive = () => st.kinds.size + (st.wall ? 1 : 0) + (st.min || st.max ? 1 : 0) + st.colours.size + (st.sale ? 1 : 0);
    async function apply(animate = true) {
      if (active() || st.sort !== 'feat') { if (pages > 1) await fetchAll(); revealAll(); }
      const before = new Map(animate && !reduce ? cards().map((c) => [c, c.getBoundingClientRect()]) : []);
      let n = 0;
      cards().forEach((c) => {
        const w = +c.dataset.w || null, p = +c.dataset.p, cols = (c.dataset.colours || '').split(',');
        const ok = (!st.kinds.size || st.kinds.has(c.dataset.k)) && (!st.sale || c.dataset.sale === '1') && (!st.max || p <= st.max) && (!st.min || p >= st.min) &&
          (!st.wall || (w && w + 20 <= st.wall)) && (!st.colours.size || cols.some((f) => st.colours.has(f)));
        c.classList.toggle('is-out', !ok); if (ok) n++;
      });
      const key = { feat: (c) => +c.dataset.i, pa: (c) => +c.dataset.p, pd: (c) => -c.dataset.p, wa: (c) => +c.dataset.w || 1e6, wd: (c) => -(+c.dataset.w || 0), new: (c) => -(+c.dataset.i) }[st.sort];
      cards().sort((a, b) => key(a) - key(b)).forEach((c) => grid.append(c));
      const vis = cards().filter((c) => !c.classList.contains('is-out'));
      tiles().sort((a, b) => b.dataset.after - a.dataset.after).forEach((t) => { const at = +t.dataset.after || 6; t.hidden = vis.length < at; if (!t.hidden) vis[at - 1].after(t); });
      before.forEach((r0, c) => {
        if (c.classList.contains('is-out')) return; const r1 = c.getBoundingClientRect();
        const dx = r0.left - r1.left, dy = r0.top - r1.top; if (!dx && !dy) return;
        c.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], { duration: 520, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
      });
      const label = `${n} ${n === 1 ? 'piece' : 'pieces'}`;
      $('#ah-plp-count').textContent = `${label}${st.wall ? ` fit a ${st.wall} cm wall` : ''}`;
      $$('[data-fbar-n]', plp).forEach((el) => (el.textContent = label));
      $$('[data-show-n]', plp).forEach((el) => (el.textContent = n));
      $('#ah-plp-empty').hidden = n > 0;
      if (moreBox) moreBox.hidden = !!active() || cards().length >= total;
      paintActive();
    }
    let at; const applySoon = () => { clearTimeout(at); at = setTimeout(() => apply(), 120); };

    function paintActive() {
      const box = $('[data-active]', plp), chips = [];
      st.kinds.forEach((k) => chips.push([`kind:${k}`, $(`.ah-fchip input[value="${k}"]`, plp)?.nextElementSibling.textContent || k]));
      if (st.wall) chips.push(['wall', `Fits a ${st.wall} cm wall`]);
      if (st.min || st.max) chips.push(['price', `${aed((st.min || 0) * 100)} to ${aed((st.max || +$('#ah-maxp').max) * 100)}`]);
      st.colours.forEach((c) => chips.push([`colour:${c}`, c]));
      if (st.sale) chips.push(['sale', 'On sale']);
      box.hidden = !chips.length;
      box.innerHTML = chips.map(([k, l]) => `<button type="button" data-rm="${k}">${esc(l)}<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>`).join('') + (chips.length ? '<button type="button" class="ah-active__clear" data-rm="all">Clear all</button>' : '');
      const fc = $('[data-fcount]', plp); const na = nActive(); if (fc) { fc.hidden = !na; fc.textContent = na; }
      $$('.ah-qchip', plp).forEach((c) => { const k = c.dataset.kindchip; const on = k ? st.kinds.size === 1 && st.kinds.has(k) : !st.kinds.size; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on); });
      $$('.ah-fchip input', plp).forEach((i) => (i.checked = st.kinds.has(i.value)));
    }

    // Quick chips: one type at a time
    $$('.ah-qchip', plp).forEach((c) => c.addEventListener('click', () => { st.kinds.clear(); if (c.dataset.kindchip) st.kinds.add(c.dataset.kindchip); apply(); }));
    // Panel
    const panel = $('#ah-fpanel', plp), scrim = $('.ah-fscrim', plp), fbtn = $('.ah-fbtn', plp);
    let lastF;
    const openPanel = () => { lastF = document.activeElement; panel.hidden = scrim.hidden = false; requestAnimationFrame(() => { panel.classList.add('is-open'); scrim.classList.add('is-open'); }); fbtn?.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('ah-lock'); $('button, input', panel)?.focus({ preventScroll: true }); if (pages > 1) fetchAll(); };
    const closePanel = () => { panel.classList.remove('is-open'); scrim.classList.remove('is-open'); fbtn?.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('ah-lock'); setTimeout(() => { panel.hidden = scrim.hidden = true; }, 420); lastF?.focus?.({ preventScroll: true }); };
    $$('[data-open-filters]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openPanel(); }));
    $$('[data-close-filters]', plp).forEach((b) => b.addEventListener('click', closePanel));
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel && !panel.hidden) closePanel(); });

    $$('.ah-fchip input', plp).forEach((i) => i.addEventListener('change', () => { i.checked ? st.kinds.add(i.value) : st.kinds.delete(i.value); applySoon(); }));
    $('[data-colours]', plp)?.addEventListener('click', (e) => { const b = e.target.closest('[data-colour]'); if (!b) return; const f = b.dataset.colour; st.colours.has(f) ? st.colours.delete(f) : st.colours.add(f); b.setAttribute('aria-pressed', st.colours.has(f)); applySoon(); });
    $('#ah-onsale')?.addEventListener('change', (e) => { st.sale = e.target.checked; applySoon(); });
    $('#ah-sort')?.addEventListener('change', (e) => { st.sort = e.target.value; apply(); });
    // Price: two handles on one track
    const mn = $('#ah-minp'), mx = $('#ah-maxp'), dual = $('.ah-dual', plp);
    const paintPrice = () => {
      let lo = +mn.value, hi = +mx.value; if (lo > hi - 100) { if (document.activeElement === mn) lo = mn.value = hi - 100; else hi = mx.value = lo + 100; }
      dual.style.setProperty('--lo', (lo / mx.max) * 100 + '%'); dual.style.setProperty('--hi', (hi / mx.max) * 100 + '%');
      $('#ah-minp-v').textContent = aed(lo * 100); $('#ah-maxp-v').textContent = aed(hi * 100);
      st.min = lo > 0 ? lo : 0; st.max = hi < +mx.max ? hi : null;
    };
    [mn, mx].forEach((r) => r?.addEventListener('input', () => { paintPrice(); applySoon(); }));
    // Wall
    const fw = $('#ah-fitw'), fwv = $('#ah-fitw-v'), fon = $('#ah-fit-on'), mt = $('.ah-minitape', plp);
    const paintTape = () => { fwv.textContent = fw.value + ' cm'; mt?.style.setProperty('--mt', ((fw.value - fw.min) / (fw.max - fw.min)) * 100 + '%'); };
    fw?.addEventListener('input', () => { paintTape(); fon.checked = true; st.wall = +fw.value; applySoon(); });
    fon?.addEventListener('change', () => { st.wall = fon.checked ? +fw.value : null; applySoon(); });
    fw && paintTape();

    function clearAll() {
      st.kinds.clear(); st.colours.clear(); st.wall = null; st.min = 0; st.max = null; st.sale = false;
      const os = $('#ah-onsale'); if (os) os.checked = false; if (fon) fon.checked = false;
      if (mn) { mn.value = 0; mx.value = mx.max; paintPrice(); }
      refreshOptions(); apply();
    }
    $('[data-active]', plp).addEventListener('click', (e) => {
      const b = e.target.closest('[data-rm]'); if (!b) return; const k = b.dataset.rm;
      if (k === 'all') return clearAll();
      if (k.startsWith('kind:')) st.kinds.delete(k.slice(5));
      else if (k === 'wall') { st.wall = null; if (fon) fon.checked = false; }
      else if (k === 'price') { mn.value = 0; mx.value = mx.max; paintPrice(); }
      else if (k.startsWith('colour:')) st.colours.delete(k.slice(7));
      else if (k === 'sale') { st.sale = false; $('#ah-onsale').checked = false; }
      refreshOptions(); apply();
    });
    $$('[data-clear-all], #ah-plp-clear', plp).forEach((b) => b.addEventListener('click', clearAll));

    refreshOptions(); paintMore(); paintActive();
  }
  /* ---------- Hero A: sketch to sofa ---------- */
  $$('[data-ah-sketch]').forEach((sec) => {
    const stage = $('.ah-sk__stage', sec), photos = $$('.ah-sk__photo', sec), sws = $$('.ah-sk__sw [data-fab]', sec), tagK = $('.ah-sk__tag .ah-k', sec);
    let fab = 0, cycle = null, touched = false, timers = [];
    const count = () => $$('[data-count]', sec).forEach((t) => {
      const to = +t.dataset.count, t0 = performance.now();
      const step = (now) => { const k = Math.min(1, (now - t0) / 900); t.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    });
    const setFab = (i, flash) => {
      fab = i;
      photos.forEach((p) => p.classList.toggle('is-on', +p.dataset.fab === i));
      sws.forEach((b) => b.setAttribute('aria-checked', +b.dataset.fab === i));
      if (tagK) tagK.textContent = 'In ' + (sws[i]?.dataset.name || '');
      if (flash && !reduce) { sec.classList.remove('is-flash'); void sec.offsetWidth; sec.classList.add('is-flash'); }
    };
    const play = () => {
      timers.forEach(clearTimeout); timers = []; clearInterval(cycle);
      sec.classList.remove('is-drawn', 'is-measured', 'is-built', 'is-flash');
      if (reduce) return;
      sec.classList.add('is-anim'); void sec.offsetWidth;
      timers.push(setTimeout(() => sec.classList.add('is-drawn'), 80));
      timers.push(setTimeout(() => { sec.classList.add('is-measured'); count(); }, 1500));
      timers.push(setTimeout(() => sec.classList.add('is-built'), 2600));
      timers.push(setTimeout(() => { if (!touched && sws.length > 1) cycle = setInterval(() => setFab((fab + 1) % sws.length, true), 4200); }, 5200));
    };
    sws.forEach((b) => b.addEventListener('click', () => { touched = true; clearInterval(cycle); setFab(+b.dataset.fab, true); }));
    $('[data-sk-replay]', sec)?.addEventListener('click', () => { touched = true; play(); });
    // The hero is the first thing on the page, so the drawing starts straight away.
    if (stage.getBoundingClientRect().top < innerHeight) play();
    else new IntersectionObserver(([e], o) => { if (e.isIntersecting) { o.disconnect(); play(); } }, { threshold: 0.25 }).observe(stage);
  });

  /* ---------- Hero B: through the logo ---------- */
  $$('[data-ah-inside]').forEach((sec) => {
    const svg = $('.ah-ins__mask', sec), logo = $('[data-ins-logo]', sec), film = $('.ah-ins__film', sec), vid = $('video', film), offer = $('[data-ins-offer]', sec);
    const OX = 186, OY = 176, BOX = { cx: 190.5, cy: 175.5, w: 381, h: 213 };
    let k = 1.4, S0 = { x: 800, y: 500 }, last = -1;
    // The stage sits under the sticky header; the announcement bar above it only shows on the first
    // screen, so the H1 block is lifted by that much to stay above the fold.
    const intro = $('.ah-ins__intro', sec);
    let hdr = 0;
    const fit = () => {
      hdr = $('.ah-section-header')?.offsetHeight || 0;
      const ann = Math.max(0, Math.round(sec.getBoundingClientRect().top + scrollY - hdr));
      sec.style.setProperty('--ins-hdr', hdr + 'px'); sec.style.setProperty('--ins-ann', ann + 'px');
      const r = svg.getBoundingClientRect(), sc = Math.max(r.width / 1600, r.height / 1000), vw = r.width / sc, vh = r.height / sc;
      // The logo is centred in the space left between the kicker and the H1 block.
      const top = intro ? intro.offsetTop + intro.offsetHeight + 12 : r.height * 0.1;
      const bot = offer ? offer.offsetTop - 16 : r.height * 0.7;
      const gap = Math.max(80, bot - top), mid = (top + bot) / 2;
      k = Math.min(1.5, (vw * 0.7) / BOX.w, ((gap / sc) * 0.84) / BOX.h);
      S0 = { x: 800 + (OX - BOX.cx) * k, y: 500 - vh / 2 + mid / sc + (OY - BOX.cy) * k };
      last = -1;
    };
    const frame = () => {
      const r = sec.getBoundingClientRect(), span = sec.offsetHeight - (innerHeight - hdr);
      const p = reduce ? 1 : Math.min(1, Math.max(0, (hdr - r.top) / Math.max(1, span)));
      if (Math.abs(p - last) > 0.0005) {
        last = p;
        const e = Math.min(1, p / 0.82), z = e * e * e;
        const K = k * Math.pow(70, z);
        logo.setAttribute('transform', `translate(${S0.x} ${S0.y}) scale(${K}) translate(${-OX} ${-OY})`);
        sec.style.setProperty('--p', p.toFixed(4));
        svg.style.opacity = p > 0.84 ? 0 : 1;
        if (vid) { const fade = Math.min(1, Math.max(0, (p - 0.42) / 0.3)); vid.style.opacity = 1 - fade * fade * (3 - 2 * fade); if (fade >= 1 && !vid.paused) vid.pause(); else if (fade < 1 && vid.paused && !reduce) vid.play().catch(() => {}); }
        film.style.transform = `scale(${1.18 - 0.18 * Math.min(1, e)})`;
        sec.classList.toggle('is-in', p > 0.8);
        if (offer) { const off = p > 0.2; if (offer.inert !== off) { offer.inert = off; offer.classList.toggle('is-off', off); } }
      }
      requestAnimationFrame(frame);
    };
    fit(); addEventListener('resize', fit, { passive: true }); addEventListener('load', fit, { once: true }); document.fonts?.ready.then(fit);
    requestAnimationFrame(frame);
    const v = $('video', sec); if (v && reduce) v.removeAttribute('autoplay');
  });

  /* ---------- Reviews wall: rows of cards drift left to right ----------
     Each row's cards are repeated until they cover twice the screen, then the track is moved with a
     transform and wrapped by one set's width, so the loop never shows a seam. Hover, focus, touch or
     the pause button stops it; dragging scrubs it. Reduced motion: no drift, drag only. */
  $$('[data-ah-wall]').forEach((wall) => {
    const btn = $('[data-wall-pause]', wall);
    let stopped = reduce, onScreen = false;
    if (btn) {
      if (reduce) btn.hidden = true;
      btn.addEventListener('click', () => { stopped = !stopped; btn.setAttribute('aria-pressed', stopped); btn.setAttribute('aria-label', stopped ? 'Play the moving reviews' : 'Pause the moving reviews'); });
    }
    new IntersectionObserver(([e]) => (onScreen = e.isIntersecting), { rootMargin: '120px' }).observe(wall);
    $$('[data-ah-marquee]', wall).forEach((row) => {
      const track = $('.ah-mq__track', row), originals = Array.from(track.children);
      if (!originals.length) return;
      const speed = +row.dataset.speed || 30;
      let setW = 0, x = 0, hold = false, drag = null, moved = false, last = 0;
      const build = () => {
        $$('[data-clone]', track).forEach((c) => c.remove());
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        setW = originals.reduce((w, c) => w + c.getBoundingClientRect().width + gap, 0);
        const copies = Math.max(2, Math.ceil((row.clientWidth * 2) / Math.max(1, setW)) + 1);
        for (let i = 1; i < copies; i++) originals.forEach((c) => { const k = c.cloneNode(true); k.dataset.clone = ''; k.setAttribute('aria-hidden', 'true'); $$('a', k).forEach((l) => (l.tabIndex = -1)); track.append(k); });
        place();
      };
      const place = () => { if (!setW) return; x = ((x % setW) + setW) % setW; track.style.transform = `translate3d(${(x - setW).toFixed(2)}px,0,0)`; };
      const tick = (t) => {
        const dt = Math.min(0.05, (t - (last || t)) / 1000); last = t;
        if (onScreen && !stopped && !hold && !drag) { x += speed * dt; place(); }
        requestAnimationFrame(tick);
      };
      row.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hold = true; });
      row.addEventListener('pointerleave', () => { if (!drag) hold = false; });
      row.addEventListener('focusin', () => (hold = true));
      row.addEventListener('focusout', () => (hold = false));
      row.addEventListener('pointerdown', (e) => { if (e.button) return; drag = { x0: e.clientX, start: x }; moved = false; });
      addEventListener('pointermove', (e) => {
        if (!drag) return;
        const d = e.clientX - drag.x0;
        if (!moved && Math.abs(d) > 6) { moved = true; row.classList.add('is-drag'); }
        if (moved) { x = drag.start + d; place(); }
      }, { passive: true });
      const end = () => { if (!drag) return; drag = null; setTimeout(() => row.classList.remove('is-drag'), 0); if (!row.matches(':hover')) hold = false; };
      addEventListener('pointerup', end); addEventListener('pointercancel', end);
      row.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      row.addEventListener('dragstart', (e) => e.preventDefault());
      build();
      let rz; new ResizeObserver(() => { clearTimeout(rz); rz = setTimeout(build, 200); }).observe(row);
      document.fonts?.ready.then(build);
      requestAnimationFrame(tick);
    });
  });

  /* ---------- Tabby: instalments line under the product price ----------
     Tabby's script draws into its own element; it is drawn again when the variant changes the price. */
  const tabby = $('[data-ah-tabby]');
  if (tabby) {
    let cents = +tabby.dataset.price;
    const draw = () => {
      if (!window.TabbyPromo) return;
      tabby.innerHTML = '<div id="ah-tabby-promo"></div>';
      tabby.classList.add('is-on');
      new window.TabbyPromo({
        selector: '#ah-tabby-promo', currency: tabby.dataset.currency, price: (cents / 100).toFixed(2),
        lang: tabby.dataset.lang, source: 'product', publicKey: tabby.dataset.key, merchantCode: tabby.dataset.merchant,
      });
    };
    const s = document.createElement('script');
    s.src = 'https://checkout.tabby.ai/tabby-promo.js'; s.async = true; s.onload = draw;
    document.head.append(s);
    document.addEventListener('ah:variant', (e) => {
      if (e.detail?.price == null || e.detail.price === cents) return;
      cents = e.detail.price; draw();
    });
  }

  /* ---------- Add to cart: the photo flies into the cart ---------- */
  document.addEventListener('ah:adding', (e) => {
    const trigger = e.detail?.trigger; if (!trigger || reduce) return;
    const card = trigger.closest('.ah-card, .ah-pdp, .ah-qv, .ah-fit, .ah-finish, .ah-room-shop');
    const img = card && ($('.ah-ph img', card) || $('#ah-gallery img', card) || $('.ah-qv__gal img', card) || $('img', card));
    const cart = $('#cart-icon-bubble'); if (!img || !cart) return;
    const a = img.getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width) return;
    const fly = img.cloneNode(); fly.removeAttribute('srcset'); fly.src = img.currentSrc || img.src;
    fly.className = 'ah-fly'; Object.assign(fly.style, { left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' });
    document.body.append(fly);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const s = Math.max(0.06, 44 / a.width);
    fly.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '14px' },
      { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - 120}px) scale(${(1 + s) / 2.4})`, opacity: 1, borderRadius: '40px', offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) scale(${s})`, opacity: 0.2, borderRadius: '50%' },
    ], { duration: 820, easing: 'cubic-bezier(0.5, 0, 0.2, 1)', fill: 'forwards' }).finished.then(() => {
      fly.remove();
      cart.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(0.94)' }, { transform: 'scale(1)' }], { duration: 520, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
    });
  });

})();
